import {
    useEffect,
    useReducer,
    useRef,
    useState,
} from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import _isEqual from 'lodash/isEqual';

import BREAKPOINTS from '@mlb/react-patterns/style/breakpoints.ts';

const XsMinWidth = parseInt(BREAKPOINTS.xs);
const SmMinWidth = parseInt(BREAKPOINTS.sm);
const MdMinWidth = parseInt(BREAKPOINTS.md);
const LgMinWidth = parseInt(BREAKPOINTS.lg);
const XlMinWidth = parseInt(BREAKPOINTS.xl);

const defaultReducer = (state, width) => {

    const newState = {};
    newState.XS = width >= XsMinWidth;
    newState.SM = width >= SmMinWidth;
    newState.MD = width >= MdMinWidth;
    newState.LG = width >= LgMinWidth;
    newState.XL = width >= XlMinWidth;

    if (_isEqual(state, newState)) {

        return state;

    }

    return newState;

};

const defaultInitialState = {
    XS: false,
    SM: false,
    MD: false,
    LG: false,
    XL: false,
};

const useNodeQuery = (initialState = defaultInitialState, reducer = defaultReducer) => {

    const [
        node,
        ref,
    ] = useState(null);
    const [
        matches,
        setMatches,
    ] = useReducer(reducer, initialState);
    const observerRef = useRef(null);

    if (!observerRef.current) {

        observerRef.current = new ResizeObserver(([entry]) => {

            setMatches(entry.borderBoxSize?.inlineSize ?? entry.contentRect.width);

        });

    }

    useEffect(() => {

        const { current: observer } = observerRef;

        if(node) {

            setMatches(node.getBoundingClientRect().width);
            observer.observe(node);

        }

        return () => {

            observer.disconnect();

        };

    }, [
        observerRef,
        node,
        setMatches,
    ]);

    return [
        matches,
        ref,
    ];

};

export default useNodeQuery;
